module.exports = __webpack_public_path__ + "img/comment1.19383ef9.svg";